import { useContext, useEffect, useState } from "react";
import { Profile, emailOtp, otp, phoneNumberOtp, updateProfile, verifyEmail, verifyUserNewPhoneNumber } from "../Services/ContectService";
import { Context } from "../Context/Context";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

const UserProfileEdit = () => {
    const [name, setName] = useState("");
    const [family, setFamily] = useState("");
    const [phone_number, setPhone_number] = useState("");
    const [initialPhoneNumber, setInitialPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [initialEmail, setInitialEmail] = useState("");
    const [national_code, setNational_code] = useState("");
    const [userInformation, setUserInformation] = useState([]);

    // resend timer sms
    const [timeLeftSms, setTimeLeftSms] = useState(null);
    const [targetTimeSms, setTargetTimeSms] = useState(null);

    const [activeResendSms, setActiveResendSms] = useState(true);
    let resendTimerIntervalSms;

    // resend timer email
    const [timeLeftEmail, setTimeLeftEmail] = useState(null);
    const [targetTimeEmail, setTargetTimeEmail] = useState(null);

    const [activeResendEmail, setActiveResendEmail] = useState(true);
    let resendTimerIntervalEmail;

    // resend code with sms function
    const calculateTimeLeftSms = (finalTime) => {
        const difference = finalTime - +new Date();
        if (difference >= 0) {
            setTimeLeftSms(Math.round(difference / 1000));
        } else {
            setTimeLeftSms(null);
            clearInterval(resendTimerIntervalSms);
            setActiveResendSms(true);
        }
    }

    const triggerTimerSms = (targetTimeInSeconds = 30) => {
        setTargetTimeSms(targetTimeInSeconds);
        setActiveResendSms(false);
        const finalTime = +new Date() + targetTimeInSeconds * 1000;
        resendTimerIntervalSms = setInterval(() => {
            calculateTimeLeftSms(finalTime);
        }, 1000)
    }

    // resend code with email function
    const calculateTimeLeftEmail = (finalTime) => {
        const difference = finalTime - +new Date();
        if (difference >= 0) {
            setTimeLeftEmail(Math.round(difference / 1000));
        } else {
            setTimeLeftEmail(null);
            clearInterval(resendTimerIntervalEmail);
            setActiveResendEmail(true);
        }
    }

    const triggerTimerEmail = (targetTimeInSeconds = 30) => {
        setTargetTimeEmail(targetTimeInSeconds);
        setActiveResendEmail(false);
        const finalTime = +new Date() + targetTimeInSeconds * 1000;
        resendTimerIntervalEmail = setInterval(() => {
            calculateTimeLeftEmail(finalTime);
        }, 1000)
    }

    // verify codes
    const [emailCode, setEmailCode] = useState("");
    const [phoneNumberCode, setPhoneNumberCode] = useState("");

    const { json, user, setLoading, numberconvert } = useContext(Context);

    const navigate = useNavigate();

    const getPhoneNumberOtpHandler = async (phoneNumber) => {
        if (!phoneNumber.trim()) {
            return toast.error("لطفاً شماره تلفن خود را وارد کنید");
        }
        setLoading(true);
        try {
            const { status } = await phoneNumberOtp({
                email_or_phone: numberconvert(phoneNumber)
            }, user);
            if (status === 200) {
                toast.success("کد تایید ارسال شد");
                triggerTimerSms();
            }
        } catch (error) {
            toast.error(json.toast.err_1);
        } finally {
            setLoading(false);
        }
    }

    const getEmailOtpHandler = async (userEmail) => {
        if (!userEmail.trim()) {
            return toast.error("لطفاً ایمیل خود را وارد کنید");
        }
        setLoading(true);
        try {
            const { status } = await emailOtp({
                email: userEmail
            }, user);
            if (status === 200) {
                toast.success("کد تایید ارسال شد");
                triggerTimerEmail();
            }
        } catch (error) {
            if (error.response.status === 400) {
                toast.error("لطفا ایمیل را به درستی وارد کنید")
            } else {
                toast.error(json.toast.err_1);
            }
        } finally {
            setLoading(false);
        }
    }

    const verifyPhoneNumberHandler = async () => {
        if (!phone_number.trim()) {
            return toast.error("لطفاً شماره تلفن خود را وارد کنید");
        }
        if (!phoneNumberCode.trim()) {
            return toast.error("لطفاً کد تایید شماره تلفن را وارد کنید");
        }
        setLoading(true);
        try {
            const { status } = await verifyUserNewPhoneNumber({
                email_or_phone: numberconvert(phone_number),
                code: numberconvert(phoneNumberCode)
            }, user);
            if (status === 200) {
                toast.success("شماره تلفن شما با موفقیت تایید شد");
                setInitialPhoneNumber(phone_number);
                setUserInformation(prevValue => ({
                    ...prevValue,
                    phone_verified: true
                }));
            }
        } catch (error) {
            if (error?.response?.status === 400) {
                toast.error("کد تایید صحیح نمی‌باشد!");
            } else {
                toast.error(json.toast.err_1);
            }
        } finally {
            setLoading(false);
        }
    }

    const verifyEmailHandler = async () => {
        if (!email.trim()) {
            return toast.error("لطفاً ایمیل خود را وارد کنید");
        }
        if (!emailCode.trim()) {
            return toast.error("لطفاً کد تایید ایمیل را وارد کنید");
        }
        setLoading(true);
        try {
            const { status } = await verifyEmail({
                email,
                code: emailCode
            }, user);
            if (status === 200) {
                toast.success("ایمیل شما با موفقیت تایید شد");
                setInitialEmail(email);
                setUserInformation(prevValue => ({
                    ...prevValue,
                    email_verified: true
                }));
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                toast.error("کد تایید صحیح نمی‌باشد!");
            } else {
                toast.error(json.toast.err_1);
            }
        } finally {
            setLoading(false);
        }
    }

    const getuserDataHandler = async () => {
        setLoading(true);
        try {
            const { status, data } = await Profile(user);
            if (status === 200) {
                setUserInformation(data);
                setName(data.name || "");
                setFamily(data.family || "");
                setPhone_number(data.phone_number || "");
                setInitialPhoneNumber(data.phone_number || "");
                setNational_code(data.national_code || "");
                setEmail(data.email || "");
                setInitialEmail(data.email || "");
                setLoading(false);
            }
        } catch (error) {
            toast.error(json.toast.err_1);
            setLoading(false);
            return navigate(-1);
        }
    }

    const handleSubmit = async event => {
        event.preventDefault();
        if (!name.trim() || !family.trim() || !email.trim() || !phone_number.trim()) {
            return toast.error("لطفاً تمام فیلدهای لازم را پر کنید");
        }
        // if (!(userInformation.phone_verified && phone_number.trim() === initialPhoneNumber.trim() && userInformation.email_verified && email.trim() === initialEmail.trim())) {
        //     return toast.error("لطفاً شماره تلفن و ایمیل خود را تایید کنید");
        // }
        if (  
            !userInformation.phone_verified ||  
            phone_number.trim() !== initialPhoneNumber.trim()  
          ) {  
            return toast.error("لطفاً شماره تلفن خود را تایید کنید");  
          }  
        if (  
            !userInformation.email_verified ||  
            email.trim() !== initialEmail.trim()  
          ) {  
            return toast.error("لطفا ایمیل خود را تایید کنید");  
          }  
        setLoading(true);
        const information = { name, family, email, national_code, phone_number };
        try {
            const { status } = await updateProfile(information, user);
            if (status === 200) {
                setLoading(false);
                return navigate("/account");
            } else {
                setLoading(false);
            }
        } catch (ex) {
            if(ex?.response?.status === 400) {
                if (ex.response.data?.code === "IS_ADMIN") {
                    toast.error("تنها sysadmin می‌تواند پروفایل شما را ویرایش کند.")
                }
                if (ex.response.data?.phone_number?.length) {
                    toast.error("این شماره تلفن در حال حاضر وجود دارد")
                }
                if (ex.response.data?.email?.length) {
                    toast.error("این ایمیل در حال حاضر وجود دارد")
                }
            }else {
                toast.error(json.toast.err_1);
            }
            setLoading(false);
        }
    }

    useEffect(() => {
        getuserDataHandler();
    }, []);

    return (<div className="lg:w-[65%] w-full rounded-xl flex bg-gray-100 border border-black">
        <form onSubmit={handleSubmit} className="account-form">
            <div className="lg:w-5/12 mt-3 lg:mt-0 w-full flex flex-col">
                <label htmlFor="name" className=" mb-2  font-bold text-gray-900">نام:</label>
                <input placeholder={userInformation.name} value={name} name="name" onChange={e => setName(e.target.value)} type="text" id="name" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
            </div>
            <div className="lg:w-5/12 w-full mt-3 lg:mt-0 flex flex-col">
                <label htmlFor="fname" className=" mb-2 font-bold text-gray-900">نام خانوادگی:</label>
                <input placeholder={userInformation.family} name="family" value={family} onChange={e => setFamily(e.target.value)} type="text" id="family" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
            </div>
            <div className="lg:w-5/12 w-full mt-3 lg:mt-0 flex flex-col">
                <label htmlFor="number" className=" mb-2 font-bold text-gray-900">شماره تلفن:</label>
                <div className="w-full flex items-center gap-1">
                    <input placeholder={userInformation.phone_number} value={phone_number} onChange={e => setPhone_number(e.target.value)} name="phone_number" type="number" id="phone_number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                    {(!userInformation?.phone_verified || phone_number.trim() !== initialPhoneNumber.trim()) && (
                        activeResendSms ? (
                        <div
                            style={{ opacity: !activeResendSms && 0.5}}
                            className="bg-blue-700 text-white rounded-lg cursor-pointer
                            px-2 py-1 whitespace-nowrap"
                            onClick={() => {activeResendSms && getPhoneNumberOtpHandler(phone_number)}}
                        >
                          دریافت کد
                        </div>
                        ) : (
                        <p
                            style={{
                                fontSize: "0.8rem",
                                marginRight: "0.4rem",
                                padding: "0.5rem"
                            }}
                        >
                        ارسال مجدد تا {timeLeftSms || targetTimeSms} ثانیه دیگر
                        </p>   
                        )
                    )}
                </div>
            </div>
            <div className="lg:w-5/12 w-full flex lg:mt-[34.5px] mt-3 justify-between items-center">
                {userInformation?.phone_verified && phone_number.trim() === initialPhoneNumber.trim() ? (
                    <div className="py-3 px-2 flex flex-nowrap gap-1 rounded-md justify-center items-center bg-green-200 h-5">
                        <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.0613 9.93875C20.2011 10.0781 20.312 10.2437 20.3878 10.426C20.4635 10.6083 20.5024 10.8038 20.5024 11.0013C20.5024 11.1987 20.4635 11.3942 20.3878 11.5765C20.312 11.7588 20.2011 11.9244 20.0613 12.0638L13.0613 19.0637C12.9219 19.2036 12.7563 19.3145 12.574 19.3903C12.3917 19.466 12.1962 19.5049 11.9988 19.5049C11.8013 19.5049 11.6059 19.466 11.4235 19.3903C11.2412 19.3145 11.0756 19.2036 10.9363 19.0637L7.93626 16.0637C7.79673 15.9242 7.68605 15.7586 7.61053 15.5763C7.53502 15.394 7.49615 15.1986 7.49615 15.0012C7.49615 14.8039 7.53502 14.6085 7.61053 14.4262C7.68605 14.2439 7.79673 14.0783 7.93626 13.9388C8.07579 13.7992 8.24143 13.6885 8.42374 13.613C8.60604 13.5375 8.80143 13.4986 8.99876 13.4986C9.19608 13.4986 9.39147 13.5375 9.57378 13.613C9.75608 13.6885 9.92173 13.7992 10.0613 13.9388L12 15.875L17.9388 9.935C18.0783 9.79578 18.2439 9.68543 18.4262 9.61027C18.6084 9.5351 18.8037 9.4966 19.0008 9.49694C19.1979 9.49729 19.393 9.53649 19.575 9.6123C19.757 9.68811 19.9222 9.79904 20.0613 9.93875ZM27.5 14C27.5 16.67 26.7082 19.2801 25.2248 21.5002C23.7414 23.7203 21.633 25.4506 19.1662 26.4724C16.6994 27.4942 13.985 27.7615 11.3663 27.2406C8.74754 26.7197 6.34207 25.434 4.45406 23.5459C2.56606 21.6579 1.28031 19.2525 0.759405 16.6337C0.238504 14.015 0.505849 11.3006 1.52763 8.83377C2.54942 6.36697 4.27974 4.25856 6.49981 2.77516C8.71987 1.29176 11.33 0.5 14 0.5C17.5792 0.50397 21.0107 1.92756 23.5416 4.45844C26.0724 6.98932 27.496 10.4208 27.5 14ZM24.5 14C24.5 11.9233 23.8842 9.89323 22.7304 8.16651C21.5767 6.4398 19.9368 5.09399 18.0182 4.29926C16.0996 3.50454 13.9884 3.29661 11.9516 3.70175C9.91476 4.1069 8.04384 5.10693 6.57538 6.57538C5.10693 8.04383 4.10691 9.91475 3.70176 11.9516C3.29662 13.9884 3.50455 16.0996 4.29927 18.0182C5.09399 19.9368 6.4398 21.5767 8.16652 22.7304C9.89324 23.8842 11.9233 24.5 14 24.5C16.7839 24.497 19.4529 23.3898 21.4213 21.4213C23.3898 19.4528 24.497 16.7839 24.5 14Z" fill="#0CBC8B" />
                        </svg>
                        <p className="text-green-500 text-xs whitespace-nowrap">تایید شده</p>
                    </div>
                ) : (
                    <div className="py-3 px-2 rounded-md flex flex-nowrap gap-1 justify-center items-center bg-red-200 h-5">
                        <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.0613 11.0612L16.125 14L19.065 16.9387C19.3468 17.2205 19.5051 17.6027 19.5051 18.0012C19.5051 18.3998 19.3468 18.782 19.065 19.0637C18.7832 19.3455 18.401 19.5039 18.0025 19.5039C17.604 19.5039 17.2218 19.3455 16.94 19.0637L14 16.125L11.0613 19.065C10.7795 19.3468 10.3973 19.5051 9.99876 19.5051C9.60024 19.5051 9.21805 19.3468 8.93626 19.065C8.65446 18.7832 8.49615 18.401 8.49615 18.0025C8.49615 17.604 8.65446 17.2218 8.93626 16.94L11.875 14L8.93876 11.0612C8.79923 10.9217 8.68855 10.7561 8.61303 10.5738C8.53752 10.3915 8.49865 10.1961 8.49865 9.99875C8.49865 9.60023 8.65696 9.21804 8.93876 8.93625C9.22055 8.65446 9.60274 8.49615 10.0013 8.49615C10.3998 8.49615 10.782 8.65446 11.0638 8.93625L14 11.875L16.9388 8.935C17.2205 8.65321 17.6027 8.4949 18.0013 8.4949C18.3998 8.4949 18.782 8.65321 19.0638 8.935C19.3455 9.21679 19.5039 9.59899 19.5039 9.9975C19.5039 10.396 19.3455 10.7782 19.0638 11.06L19.0613 11.0612ZM27.5 14C27.5 16.67 26.7082 19.2801 25.2248 21.5002C23.7414 23.7203 21.633 25.4506 19.1662 26.4724C16.6994 27.4942 13.985 27.7615 11.3663 27.2406C8.74754 26.7197 6.34207 25.434 4.45406 23.5459C2.56606 21.6579 1.28031 19.2525 0.759405 16.6337C0.238504 14.015 0.505849 11.3006 1.52763 8.83377C2.54942 6.36697 4.27974 4.25856 6.49981 2.77516C8.71987 1.29176 11.33 0.5 14 0.5C17.5792 0.50397 21.0107 1.92756 23.5416 4.45844C26.0724 6.98932 27.496 10.4208 27.5 14ZM24.5 14C24.5 11.9233 23.8842 9.89323 22.7304 8.16651C21.5767 6.4398 19.9368 5.09399 18.0182 4.29926C16.0996 3.50454 13.9884 3.29661 11.9516 3.70175C9.91476 4.1069 8.04384 5.10693 6.57538 6.57538C5.10693 8.04383 4.10691 9.91475 3.70176 11.9516C3.29662 13.9884 3.50455 16.0996 4.29927 18.0182C5.09399 19.9368 6.4398 21.5767 8.16652 22.7304C9.89324 23.8842 11.9233 24.5 14 24.5C16.7839 24.497 19.4529 23.3898 21.4213 21.4213C23.3898 19.4528 24.497 16.7839 24.5 14Z" fill="#FF0000" />
                        </svg>
                        <p className="text-red-600 text-xs whitespace-nowrap">تایید نشده</p>
                    </div>
                )}
                <div className="flex items-center">
                    <input
                        type="text"
                        disabled={userInformation?.phone_verified && phone_number.trim() === initialPhoneNumber.trim()}
                        className={`mr-2 w-28 h-8 bg-gray-50 border border-gray-300 ml-4
                        text-sm rounded-lg focus:ring-blue-500 
                        focus:border-blue-500 block p-2.5
                        ${userInformation?.phone_verified && phone_number.trim() === initialPhoneNumber.trim() ? "text-gray-400" : "text-gray-900"}`}
                        name="phoneNumberCode"
                        id="phoneNumberCode"
                        value={phoneNumberCode}
                        onChange={(ev) => setPhoneNumberCode(ev.target.value)}
                    />
                    <div
                        className={`cursor-pointer bg-blue-700 text-white rounded-lg px-4 py-1 whitespace-nowrap
                        ${userInformation?.phone_verified && phone_number.trim() === initialPhoneNumber.trim() ?
                            "opacity-50 pointer-events-none" :
                            ""}`}
                        onClick={() => verifyPhoneNumberHandler()}
                    >
                        تایید کد
                    </div>
                </div>
            </div>
            <div className="lg:w-5/12 mt-3 lg:mt-0 w-full flex flex-col">
                <label htmlFor="email" className=" mb-2  font-bold text-gray-900">ایمیل:</label>
                <div className="w-full flex items-center gap-1">
                    <input placeholder={userInformation.email} name="email" value={email} onChange={e => setEmail(e.target.value)} type="email" id="email" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
                    {(!userInformation?.email_verified || email.trim() !== initialEmail.trim()) && (
                        activeResendEmail ? (
                            <div
                                style={{ opacity: !activeResendEmail && 0.5}}
                                className="bg-blue-700 text-white rounded-lg cursor-pointer
                                px-2 py-1 whitespace-nowrap"
                                onClick={() => {activeResendEmail && getEmailOtpHandler(email)}}
                            >
                              دریافت کد
                            </div>
                            ) : (
                            <p
                                style={{
                                    fontSize: "0.8rem",
                                    marginRight: "0.4rem",
                                    padding: "0.5rem"
                                }}
                            >
                            ارسال مجدد تا {timeLeftEmail || targetTimeEmail} ثانیه دیگر
                            </p> 
                            )
                    )}
                </div>
            </div>
            <div className="lg:w-5/12 w-full flex lg:mt-[34.5px] mt-3 justify-between items-center">
                {userInformation?.email_verified && email.trim() === initialEmail.trim() ? (
                    <div className="py-3 px-2 flex flex-nowrap gap-1 rounded-md justify-center items-center bg-green-200 h-5">
                        <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.0613 9.93875C20.2011 10.0781 20.312 10.2437 20.3878 10.426C20.4635 10.6083 20.5024 10.8038 20.5024 11.0013C20.5024 11.1987 20.4635 11.3942 20.3878 11.5765C20.312 11.7588 20.2011 11.9244 20.0613 12.0638L13.0613 19.0637C12.9219 19.2036 12.7563 19.3145 12.574 19.3903C12.3917 19.466 12.1962 19.5049 11.9988 19.5049C11.8013 19.5049 11.6059 19.466 11.4235 19.3903C11.2412 19.3145 11.0756 19.2036 10.9363 19.0637L7.93626 16.0637C7.79673 15.9242 7.68605 15.7586 7.61053 15.5763C7.53502 15.394 7.49615 15.1986 7.49615 15.0012C7.49615 14.8039 7.53502 14.6085 7.61053 14.4262C7.68605 14.2439 7.79673 14.0783 7.93626 13.9388C8.07579 13.7992 8.24143 13.6885 8.42374 13.613C8.60604 13.5375 8.80143 13.4986 8.99876 13.4986C9.19608 13.4986 9.39147 13.5375 9.57378 13.613C9.75608 13.6885 9.92173 13.7992 10.0613 13.9388L12 15.875L17.9388 9.935C18.0783 9.79578 18.2439 9.68543 18.4262 9.61027C18.6084 9.5351 18.8037 9.4966 19.0008 9.49694C19.1979 9.49729 19.393 9.53649 19.575 9.6123C19.757 9.68811 19.9222 9.79904 20.0613 9.93875ZM27.5 14C27.5 16.67 26.7082 19.2801 25.2248 21.5002C23.7414 23.7203 21.633 25.4506 19.1662 26.4724C16.6994 27.4942 13.985 27.7615 11.3663 27.2406C8.74754 26.7197 6.34207 25.434 4.45406 23.5459C2.56606 21.6579 1.28031 19.2525 0.759405 16.6337C0.238504 14.015 0.505849 11.3006 1.52763 8.83377C2.54942 6.36697 4.27974 4.25856 6.49981 2.77516C8.71987 1.29176 11.33 0.5 14 0.5C17.5792 0.50397 21.0107 1.92756 23.5416 4.45844C26.0724 6.98932 27.496 10.4208 27.5 14ZM24.5 14C24.5 11.9233 23.8842 9.89323 22.7304 8.16651C21.5767 6.4398 19.9368 5.09399 18.0182 4.29926C16.0996 3.50454 13.9884 3.29661 11.9516 3.70175C9.91476 4.1069 8.04384 5.10693 6.57538 6.57538C5.10693 8.04383 4.10691 9.91475 3.70176 11.9516C3.29662 13.9884 3.50455 16.0996 4.29927 18.0182C5.09399 19.9368 6.4398 21.5767 8.16652 22.7304C9.89324 23.8842 11.9233 24.5 14 24.5C16.7839 24.497 19.4529 23.3898 21.4213 21.4213C23.3898 19.4528 24.497 16.7839 24.5 14Z" fill="#0CBC8B" />
                        </svg>
                        <p className="text-green-500 text-xs whitespace-nowrap">تایید شده</p>
                    </div>
                ) : (
                    <div className="py-3 px-2 rounded-md flex flex-nowrap gap-1 justify-center items-center bg-red-200 h-5">
                        <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.0613 11.0612L16.125 14L19.065 16.9387C19.3468 17.2205 19.5051 17.6027 19.5051 18.0012C19.5051 18.3998 19.3468 18.782 19.065 19.0637C18.7832 19.3455 18.401 19.5039 18.0025 19.5039C17.604 19.5039 17.2218 19.3455 16.94 19.0637L14 16.125L11.0613 19.065C10.7795 19.3468 10.3973 19.5051 9.99876 19.5051C9.60024 19.5051 9.21805 19.3468 8.93626 19.065C8.65446 18.7832 8.49615 18.401 8.49615 18.0025C8.49615 17.604 8.65446 17.2218 8.93626 16.94L11.875 14L8.93876 11.0612C8.79923 10.9217 8.68855 10.7561 8.61303 10.5738C8.53752 10.3915 8.49865 10.1961 8.49865 9.99875C8.49865 9.60023 8.65696 9.21804 8.93876 8.93625C9.22055 8.65446 9.60274 8.49615 10.0013 8.49615C10.3998 8.49615 10.782 8.65446 11.0638 8.93625L14 11.875L16.9388 8.935C17.2205 8.65321 17.6027 8.4949 18.0013 8.4949C18.3998 8.4949 18.782 8.65321 19.0638 8.935C19.3455 9.21679 19.5039 9.59899 19.5039 9.9975C19.5039 10.396 19.3455 10.7782 19.0638 11.06L19.0613 11.0612ZM27.5 14C27.5 16.67 26.7082 19.2801 25.2248 21.5002C23.7414 23.7203 21.633 25.4506 19.1662 26.4724C16.6994 27.4942 13.985 27.7615 11.3663 27.2406C8.74754 26.7197 6.34207 25.434 4.45406 23.5459C2.56606 21.6579 1.28031 19.2525 0.759405 16.6337C0.238504 14.015 0.505849 11.3006 1.52763 8.83377C2.54942 6.36697 4.27974 4.25856 6.49981 2.77516C8.71987 1.29176 11.33 0.5 14 0.5C17.5792 0.50397 21.0107 1.92756 23.5416 4.45844C26.0724 6.98932 27.496 10.4208 27.5 14ZM24.5 14C24.5 11.9233 23.8842 9.89323 22.7304 8.16651C21.5767 6.4398 19.9368 5.09399 18.0182 4.29926C16.0996 3.50454 13.9884 3.29661 11.9516 3.70175C9.91476 4.1069 8.04384 5.10693 6.57538 6.57538C5.10693 8.04383 4.10691 9.91475 3.70176 11.9516C3.29662 13.9884 3.50455 16.0996 4.29927 18.0182C5.09399 19.9368 6.4398 21.5767 8.16652 22.7304C9.89324 23.8842 11.9233 24.5 14 24.5C16.7839 24.497 19.4529 23.3898 21.4213 21.4213C23.3898 19.4528 24.497 16.7839 24.5 14Z" fill="#FF0000" />
                        </svg>
                        <p className="text-red-600 text-xs whitespace-nowrap">تایید نشده</p>
                    </div>
                )}
                <div className="flex items-center">
                    <input
                        type="text"
                        disabled={userInformation?.email_verified && email.trim() === initialEmail.trim()}
                        className={`mr-2 w-28 h-8 bg-gray-50 border border-gray-300 ml-4 
                        text-sm rounded-lg focus:ring-blue-500 
                        focus:border-blue-500 block p-2.5
                        ${userInformation?.email_verified && email.trim() === initialEmail.trim() ? "text-gray-400" : "text-gray-900"}`}
                        name="emailCode"
                        id="emailCode"
                        value={emailCode}
                        onChange={(ev) => setEmailCode(ev.target.value)}
                    />
                    <div
                        className={`cursor-pointer bg-blue-700 text-white rounded-lg px-4 py-1 whitespace-nowrap
                        ${userInformation?.email_verified && email.trim() === initialEmail.trim() ?
                                "opacity-50 pointer-events-none" :
                                ""}`}
                        onClick={() => verifyEmailHandler()}
                    >
                        تایید کد
                    </div>
                </div>
            </div>
            <div className="lg:w-5/12 mt-3 lg:mt-0 w-full flex flex-col">
                <label htmlFor="icode" className=" mb-2  font-bold text-gray-900">کد ملی:</label>
                <input placeholder={userInformation.national_code} name="national_code" value={national_code} onChange={e => setNational_code(e.target.value)} type="number" id="icode" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" />
            </div>
            <div className="lg:w-5/12  w-full mt-[28px]  flex flex-col pb-3 lg:pb-0">
                <div className="w-full mt-3 mb-4 flex-row-reverse flex">
                    <Link to="/account" className="bg-blue-700 justify-center items-center w-40 p-2 rounded-lg flex cursor-pointer">
                        <svg width="22" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.5012 11C25.5012 11.3978 25.3431 11.7794 25.0618 12.0607C24.7805 12.342 24.399 12.5 24.0012 12.5H5.62618L12.0662 18.9388C12.348 19.2206 12.5063 19.6027 12.5063 20.0013C12.5063 20.3998 12.348 20.782 12.0662 21.0638C11.7844 21.3456 11.4022 21.5039 11.0037 21.5039C10.6052 21.5039 10.223 21.3456 9.94118 21.0638L0.941183 12.0638C0.801343 11.9244 0.690387 11.7588 0.614679 11.5765C0.538971 11.3942 0.5 11.1987 0.5 11.0013C0.5 10.8038 0.538971 10.6084 0.614679 10.426C0.690387 10.2437 0.801343 10.0781 0.941183 9.93876L9.94118 0.938759C10.0807 0.799229 10.2464 0.688548 10.4287 0.613036C10.611 0.537523 10.8064 0.498657 11.0037 0.498657C11.201 0.498657 11.3964 0.537523 11.5787 0.613036C11.761 0.688548 11.9267 0.799229 12.0662 0.938759C12.2057 1.07829 12.3164 1.24393 12.3919 1.42624C12.4674 1.60854 12.5063 1.80393 12.5063 2.00126C12.5063 2.19858 12.4674 2.39398 12.3919 2.57628C12.3164 2.75858 12.2057 2.92423 12.0662 3.06376L5.62618 9.50001H24.0012C24.399 9.50001 24.7805 9.65804 25.0618 9.93935C25.3431 10.2207 25.5012 10.6022 25.5012 11Z" fill="white" />
                        </svg>
                        <p className="text-white mr-3">بازگشت</p>
                    </Link>
                    <button type="submit" className="ml-4 bg-blue-700 justify-center items-center w-40 p-2 rounded-lg flex cursor-pointer">
                        <svg width="20" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M25.2395 3.06126L9.69263 19.0613C9.55722 19.2011 9.39632 19.3121 9.21916 19.3878C9.042 19.4635 8.85205 19.5024 8.66022 19.5024C8.4684 19.5024 8.27845 19.4635 8.10129 19.3878C7.92413 19.3121 7.76323 19.2011 7.62782 19.0613L0.826075 12.0613C0.690497 11.9217 0.582951 11.7561 0.509577 11.5738C0.436203 11.3915 0.398438 11.1961 0.398438 10.9988C0.398437 10.8014 0.436203 10.606 0.509577 10.4237C0.582951 10.2414 0.690497 10.0758 0.826075 9.93626C0.961652 9.79673 1.12261 9.68605 1.29975 9.61054C1.47689 9.53502 1.66675 9.49616 1.85848 9.49616C2.05022 9.49616 2.24008 9.53502 2.41722 9.61054C2.59436 9.68605 2.75531 9.79673 2.89089 9.93626L8.66144 15.875L23.1771 0.938759C23.4509 0.656966 23.8223 0.498657 24.2095 0.498657C24.5967 0.498657 24.9681 0.656966 25.2419 0.938759C25.5157 1.22055 25.6695 1.60274 25.6695 2.00126C25.6695 2.39977 25.5157 2.78197 25.2419 3.06376L25.2395 3.06126Z" fill="white" />
                        </svg>
                        <p className="text-white mr-3">ذخیره اطلاعات</p>
                    </button>
                </div>
            </div>
        </form>
    </div>);
}

export default UserProfileEdit;